document.addEventListener('DOMContentLoaded', function () {
  function initEnaviProgressBar(SmartCart) {
    if (!SmartCart) {
      return;
    }

    const TIER_THRESHOLDS = [10000, 15000, 20000];
    const MAX_PROGRESS = 100;
    const TIER_WIDTH = MAX_PROGRESS / TIER_THRESHOLDS.length;
    
    // Define icon offsets for each tier (in percentage)
    const ICON_OFFSETS = {
      desktop: [5.3, 51.5, 98],
      mobile: [6, 51.5, 97]
    };

    // Function to get current icon offsets based on screen width
    function getCurrentIconOffsets() {
      return window.innerWidth > 510 ? ICON_OFFSETS.desktop : ICON_OFFSETS.mobile;
    }

    // Elements
    const enaviProgressBar = document?.querySelector('.enavi-custom-progress-bar');
    if (!enaviProgressBar) { return; }
    const progressBar = enaviProgressBar.querySelector('.rebuy-cart__progress-bar-meter-fill');
    const tierIcons = [
      enaviProgressBar.querySelector('.shipping_step'),
      enaviProgressBar.querySelector('.gift_step-150'),
      enaviProgressBar.querySelector('.gift_step-200'),
    //  enaviProgressBar.querySelector('.gift_step-250'),
    //  enaviProgressBar.querySelector('.gift_step-500')
    ];
    const tierAmount = enaviProgressBar.querySelector('.enavi-tier-amount');
    const tierReward = enaviProgressBar.querySelector('.enavi-tier-reward');
    const tierInfo = enaviProgressBar.querySelector('.enavi-tier-info');

    if (!enaviProgressBar || !progressBar || tierIcons.some(icon => !icon) || !tierAmount || !tierReward || !tierInfo) {
      console.error('One or more elements are not found in the DOM.');
      return;
    }

    // Calculate cart total and progress
    let cartTotal = SmartCart.cart.total_price;
    let currentTier = TIER_THRESHOLDS.findIndex(threshold => cartTotal < threshold);
    if (currentTier === -1) currentTier = TIER_THRESHOLDS.length; // If cart total exceeds all thresholds

    let calculatedWidth;
    if (currentTier < TIER_THRESHOLDS.length) {
      let previousThreshold = currentTier > 0 ? TIER_THRESHOLDS[currentTier - 1] : 0;
      let progressWithinTier = (cartTotal - previousThreshold) / (TIER_THRESHOLDS[currentTier] - previousThreshold);
      
      // Get current icon offsets based on screen width
      const currentIconOffsets = getCurrentIconOffsets();
      
      // Adjust calculation to account for current icon offsets
      let previousOffset = currentTier > 0 ? currentIconOffsets[currentTier - 1] : 0;
      let currentOffset = currentIconOffsets[currentTier];
      calculatedWidth = previousOffset + (progressWithinTier * (currentOffset - previousOffset));
    } else {
      calculatedWidth = MAX_PROGRESS;
    }

    // Determine remaining amount to next goal and reward text
    let remainingToGoal = currentTier < TIER_THRESHOLDS.length ? TIER_THRESHOLDS[currentTier] - cartTotal : 0;
    let tierRewardText = currentTier === 0 ? 'Free Shipping + Free Gift' : 
                        currentTier < TIER_THRESHOLDS.length ? 'Free Gift Upgrade' : 
                        'Free Gift Upgrade Unlocked';

    // Update tier icons
    tierIcons.forEach((icon, index) => {
      if (index < currentTier) {
        icon.classList.add('complete');
      } else {
        icon.classList.remove('complete');
      }
    });

    // Update the progress bar and text elements
    progressBar.style.width = `${calculatedWidth}%`;
    if (remainingToGoal > 0) {
      tierAmount.style.display = 'block';
      tierReward.style.display = 'block';
      tierAmount.innerText = SmartCart.formatMoney(remainingToGoal);
      tierReward.innerText = tierRewardText;
      tierInfo.innerText = ' away from ';
    } else {
      tierAmount.style.display = 'none';
      tierReward.style.display = 'none';
      tierInfo.innerText = tierRewardText;
    }
  }

  document.addEventListener('rebuy:smartcart.ready', (event) => {
    initEnaviProgressBar(event.detail.smartcart);
  });

  document.addEventListener('rebuy:cart.change', (event) => {
    let SmartCart = window.Rebuy.SmartCart;
    SmartCart = { ...event.detail.cart };
    initEnaviProgressBar(SmartCart);
  });

  document.addEventListener('rebuy:smartcart.show', (event) => {
    initEnaviProgressBar(event.detail.smartcart);
  });

  // Add resize event listener to update progress bar when screen size changes
  window.addEventListener('resize', () => {
    let SmartCart = window.Rebuy.SmartCart;
    initEnaviProgressBar(SmartCart);
  });
});